<template>
    <div>
        <NavBarAdmin></NavBarAdmin>
        <h3 class="mt-3">Nuevo tubo metálico</h3>
        <FormNewTube></FormNewTube>
        <FooterAdmin></FooterAdmin>
    </div>
</template>
<script>
import NavBarAdmin from "@/components/Admin/NavbarAdminComponent.vue"
import FormNewTube from "@/components/Admin/Tube/NewTubeFormComponent.vue"
import FooterAdmin from "@/components/Admin/FooterAdminComponent.vue"
export default{
    data(){
        return{

        }
    },
    components:{
        NavBarAdmin,
        FooterAdmin,
        FormNewTube,
    }
}
</script>
<style scoped>

</style>